var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.81667 3.8833C1.64178 3.8833 1.5 4.02508 1.5 4.19997V15.9333C1.5 16.1082 1.64178 16.25 1.81667 16.25H15.6833C15.8582 16.25 16 16.1082 16 15.9333V4.19997C16 4.02508 15.8582 3.8833 15.6833 3.8833H1.81667ZM0 4.19997C0 3.19665 0.813349 2.3833 1.81667 2.3833H15.6833C16.6867 2.3833 17.5 3.19665 17.5 4.19997V15.9333C17.5 16.9366 16.6867 17.75 15.6833 17.75H1.81667C0.813349 17.75 0 16.9366 0 15.9333V4.19997Z",
  fill: "#8A8A8A"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 7.3999C0 6.98569 0.335786 6.6499 0.75 6.6499H16.75C17.1642 6.6499 17.5 6.98569 17.5 7.3999C17.5 7.81412 17.1642 8.1499 16.75 8.1499H0.75C0.335786 8.1499 0 7.81412 0 7.3999Z",
  fill: "#8A8A8A"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.0166 0.25C5.43082 0.25 5.7666 0.585786 5.7666 1V4.73333C5.7666 5.14755 5.43082 5.48333 5.0166 5.48333C4.60239 5.48333 4.2666 5.14755 4.2666 4.73333V1C4.2666 0.585786 4.60239 0.25 5.0166 0.25Z",
  fill: "#8A8A8A"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.4834 0.25C12.8976 0.25 13.2334 0.585786 13.2334 1V4.73333C13.2334 5.14755 12.8976 5.48333 12.4834 5.48333C12.0692 5.48333 11.7334 5.14755 11.7334 4.73333V1C11.7334 0.585786 12.0692 0.25 12.4834 0.25Z",
  fill: "#8A8A8A"
})));
export default SvgCalendar;